import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFactory = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "factory" }, /* @__PURE__ */ React.createElement("path", { id: "Union", d: "M1 11V4.9875L4.5 3.5V4.5L7 3.5V5H11V11H1ZM5.5 9H6.5V7H5.5V9ZM3.5 9H4.5V7H3.5V9ZM7.5 9H8.5V7H7.5V9ZM10.9 4.25H8.5875L9.0125 1H10.5L10.9 4.25Z" })));
const ForwardRef = forwardRef(SvgFactory);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
